// @flow
import client from '../../client'

// Endpoints
export const GET_FLIGHTS_ENDPOINT = '/flights/'

// Types
export type Flight = {
  destination: string,
  airlineName: string,
  airlineCode: string,
  flightCode: string,
  flightNumber: string,
  flightDatetime: string,
  origin: string,
  time: string,
}
type Options = {
  airline_code: string,
  airport_code: string,
  flight_number?: string,
  flight_direction: string,
  flight_datetime?: string,
  pickup_datetime?: string,
}

/**
 * Get flights according to an airline and flight time
 * @param {Object} data Flight data
 * @param {string} data.airline_code Flights airline code
 * @param {string} data.airport_code Airport IATA code
 * @param {string} data.flight_direction Flight direction
 * @param {string} data.pickup_datetime Pickup datetime
 * @return {Promise|Error} A resolved Promise with an Array of Flight Objects or Rejected with an Error
 */
export const getFlights = (data: Options): Promise<Flight[]> =>
  client
    .get(GET_FLIGHTS_ENDPOINT, { query: data })
    .then((response): Array<Flight> =>
      response.flights.map((flight): Flight => ({
        airlineName: flight.airline.airline_name,
        airlineCode: flight.airline.airline_code,
        destination: flight.destination,
        flightCode: flight.flight_code,
        flightNumber: flight.flight_number,
        flightDatetime: flight.datetime,
        origin: flight.origin,
        time: flight.time,
      }))
    )

export default getFlights
